import React from "react";
import PropTypes from "prop-types";
import { Link } from "@chakra-ui/react";
import { LocalizedLink } from "features/navigation";

const MenuLink = ({ slug, children, ...rest }) => {
  const slugIsString = typeof slug === "string";
  const isExternal = slugIsString && slug.startsWith("http");
  const internalHref = slugIsString
    ? slug.startsWith("/")
      ? slug
      : `/${slug}`
    : "/";

  if (isExternal) {
    return (
      <Link isExternal href={slug} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <Link as={LocalizedLink} to={internalHref} {...rest}>
      {children}
    </Link>
  );
};

MenuLink.propTypes = {
  slug: PropTypes.string,
  children: PropTypes.node,
};

export default MenuLink;
